import React from 'react';
import { Icon } from './Icon.js';
export const IconLoader2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M0 6C0 2.68629 2.68629 0 6 0V1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5V12C2.68629 12 0 9.31371 0 6Z", fill: "url(#paint0_linear_168_1709)" }),
        React.createElement("path", { d: "M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5V0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12V10.5C8.48528 10.5 10.5 8.48528 10.5 6Z", fill: "url(#paint1_linear_168_1709)" }),
        React.createElement("path", { d: "M6 12C6.41421 12 6.75 11.6642 6.75 11.25C6.75 10.8358 6.41421 10.5 6 10.5C5.58579 10.5 5.25 10.8358 5.25 11.25C5.25 11.6642 5.58579 12 6 12Z", fill: "currentColor" }),
        React.createElement("defs", { fill: "none" },
            " ",
            React.createElement("linearGradient", { id: "paint0_linear_168_1709", x1: "6", y1: "1.2931", x2: "6", y2: "11.25", gradientUnits: "userSpaceOnUse", fill: "none" },
                " ",
                React.createElement("stop", { stopOpacity: "0.5", fill: "none" }),
                " ",
                React.createElement("stop", { offset: "1", stopOpacity: "0", fill: "none" }),
                " "),
            " ",
            React.createElement("linearGradient", { id: "paint1_linear_168_1709", x1: "6", y1: "1.2931", x2: "6", y2: "11.25", gradientUnits: "userSpaceOnUse", fill: "none" },
                " ",
                React.createElement("stop", { stopOpacity: "0.5", fill: "none" }),
                " ",
                React.createElement("stop", { offset: "1", fill: "none" }),
                " "),
            " ")));
};
//# sourceMappingURL=IconLoader2Fill12.js.map